import { render } from "./LibraryAlbum.vue?vue&type=template&id=1a24bc8d&ts=true"
import script from "./LibraryAlbum.vue?vue&type=script&lang=ts"
export * from "./LibraryAlbum.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\vdmar\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__